// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"93":"list","177":"home","180":"story"}[chunkId] || chunkId) + "-" + {"93":"816cf277c36c578a9b52","177":"979cd03cd81ae07f1965","180":"65befd6dcf11fe10c291","628":"1b4af44e64f845b3636b"}[chunkId] + ".css";
};